import React, { useState } from 'react';
import { ChevronDown, Package } from 'lucide-react';
import { useCart } from '../../context/CartContext';

const OrdersView = () => {
  const { orders } = useCart();
  const [expanded, setExpanded] = useState(null);

  if (orders.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-24 space-y-3">
        <p className="text-foreground-muted text-lg">No orders yet</p>
        <p className="text-sm text-foreground-secondary">Your order history will appear here after checkout.</p>
      </div>
    );
  }

  return (
    <div>
      <h2 className="text-2xl font-bold text-foreground-primary mb-6">My Orders</h2>
      <div className="space-y-3">
        {orders.map((order) => (
          <div key={order.id} className="glass-frosted rounded-xl glow-subtle overflow-hidden">
            <button
              onClick={() => setExpanded(expanded === order.id ? null : order.id)}
              className="w-full flex items-center justify-between p-5"
            >
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ background: 'rgba(249,115,22,0.1)' }}>
                  <Package size={18} style={{ color: '#F97316' }} />
                </div>
                <div className="text-left">
                  <p className="text-sm font-semibold text-foreground-primary font-mono">{order.id}</p>
                  <p className="text-xs text-foreground-muted">{new Date(order.date).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <span
                  className="text-[11px] font-semibold px-2.5 py-1 rounded-full"
                  style={{
                    background: order.status === 'Processing' ? 'rgba(234,179,8,0.1)' : 'rgba(34,197,94,0.1)',
                    color: order.status === 'Processing' ? '#eab308' : '#22c55e',
                  }}
                >
                  {order.status}
                </span>
                <span className="text-sm font-bold" style={{ color: '#F97316' }}>
                  {order.total === 0 ? 'Free' : `₹${order.total.toLocaleString()}`}
                </span>
                <ChevronDown size={16} className={`text-foreground-muted transition-transform ${expanded === order.id ? 'rotate-180' : ''}`} />
              </div>
            </button>

            {expanded === order.id && (
              <div className="px-5 pb-5 border-t border-subtle">
                <table className="w-full text-sm mt-4">
                  <thead>
                    <tr className="border-b border-subtle">
                      <th className="text-left py-2 text-foreground-muted font-medium">Item</th>
                      <th className="text-center py-2 text-foreground-muted font-medium">Qty</th>
                      <th className="text-right py-2 text-foreground-muted font-medium">Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {order.items.map((item) => (
                      <tr key={item.id} className="border-b border-subtle last:border-b-0">
                        <td className="py-2.5">
                          <p className="text-foreground-primary font-medium">{item.name}</p>
                          <p className="text-[11px] text-foreground-muted">{item.category}</p>
                        </td>
                        <td className="py-2.5 text-center text-foreground-secondary">{item.qty}</td>
                        <td className="py-2.5 text-right text-foreground-secondary">
                          {item.price === 0 ? 'Free' : `${item.currency}${(item.price * item.qty).toLocaleString()}`}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrdersView;
